import React from "react";

const Chapter5 = () => {
  return (
    <>
      <h2>
        Is <em>E. coli</em> a regulated pollutant?
      </h2>
      <p>
        Yes. The US Environmental Protection Agency regulates <em>E. coli</em>{" "}
        in recreational water through the Clean Water Act and drinking water
        through the Safe Drinking Water Act. Colorado regulates <em>E. coli</em>{" "}
        through the Water Quality Control Commission Regulations.
      </p>
    </>
  );
};

export default Chapter5;
